import attendanceGridApi from '../../../api/st-attendance-grid';
import { CalendarService } from './CalendarService';
import { SectionVerificationData } from '../../../api';

export interface VerificationCheckResult {
    hasVerification: boolean;
    hasDocument: boolean;
    isPending: boolean;
    documentGU: string;
    staffAttendanceVerifyGU: string;
    status: string;
    sectionVerifications: SectionVerificationData[];
}

/**
 * Attendance verification service - handles verification checking and document downloads
 */
export class AttendanceVerificationService {
    /**
     * Check if a week already has a verification record
     */
    static async checkWeekVerification(startDate: Date, endDate: Date): Promise<VerificationCheckResult> {
        const startDateStr = CalendarService.formatDateForApi(startDate);
        const endDateStr = CalendarService.formatDateForApi(endDate);

        const response = await attendanceGridApi.CheckAttendanceVerification({
            startDate: startDateStr,
            endDate: endDateStr
        });

        if (!response.success) {
            throw new Error(response.errorMessage || 'Failed to check verification status');
        }

        return {
            hasVerification: response.hasVerification ?? false,
            hasDocument: response.hasDocument ?? false,
            isPending: response.isPending ?? false,
            documentGU: response.personAtcDocGU ?? '',
            staffAttendanceVerifyGU: response.staffAttendanceVerifyGU ?? '',
            status: response.status ?? '',
            sectionVerifications: response.sectionVerifications ?? []
        };
    }

    /**
     * Download a verification document
     */
    static async downloadDocument(documentGU: string): Promise<void> {
        if (!documentGU) {
            throw new Error('No document available to download');
        }

        const response = await attendanceGridApi.DownloadAttendanceDocument({
            personAtcDocGU: documentGU
        });

        if (!response.success) {
            throw new Error(response.errorMessage || 'Failed to download document');
        }

        if (response.fileVirtualPath) {
            window.open(response.fileVirtualPath, '_blank');
        } else {
            throw new Error('No file path returned from server');
        }
    }
}
